module.exports = function getResource(label, vars = []) {
    const resources = {
        zeroResult: 'Désolé, nous n’avons pas trouvé de résultats.',
        updateFilter: 'Essayer de changer ou de supprimer vos filtres.'
    };

    return resources[label];
};
